import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getSequenceConfigValues = () => apiActionCreator({
  'endpoint': '/orders/providers/sequential',
  'authenticated': true,
  'types': [
    ActionTypes.LOAD_PROVIDER_ORDER_ABBREVIATIONS_REQUEST,
    [
      ActionTypes.LOAD_PROVIDER_ORDER_ABBREVIATIONS_SUCCESS,
    ],
    [
      ActionTypes.LOAD_PROVIDER_ORDER_ABBREVIATIONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const saveSequenceConfigValues = (data) => apiActionCreator({
  'endpoint': '/orders/providers/sequential',
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_PROVIDER_ORDER_ABBREVIATIONS_REQUEST,
    [
      {
        'type': ActionTypes.SAVE_PROVIDER_ORDER_ABBREVIATIONS_SUCCESS,
        'payload': data,
      },
    ],
    [
      ActionTypes.SAVE_PROVIDER_ORDER_ABBREVIATIONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const changeSequenceConfigParameter = (field, value) => ({
  'type': ActionTypes.CHANGE_PROVIDER_ORDER_SEQUENCE_PARAMETER,
  'payload': {field, value},
});

export const selectSequenceConfigAbbreviation = (abbreviation) => ({
  'type': ActionTypes.SELECT_PROVIDER_ORDER_ABBREVIATION,
  'payload': abbreviation,
});

export const findAbbreviationByName = (name) => ({
  'type': ActionTypes.FIND_ABBREVIATION_BY_TYPE_AND_NAME,
  'payload': name,
});
